import Vue from 'vue'
import VueRouter from 'vue-router'


Vue.use(VueRouter)

const originalPush = VueRouter.prototype.push
VueRouter.prototype.push = function push(location, onResolve, onReject) {
  if (onResolve || onReject) return originalPush.call(this, location, onResolve, onReject)
  return originalPush.call(this, location).catch(err => err)
}

//--------组件
import Login from '../components/Login'
import Layout from '../components/layout/index.vue'
//------首页

import Instrument from '../pages/instrument/index.vue'

/**
 * import NotFound from '../pages/errorPage/404.vue'
    import Forbidden from '../pages/errorPage/403.vue'
 * 
 */

//------初始化路由
const routes = [
  {
    path: '/Login',
    name: 'Login',
    component: Login
  }
]

/*
  根据用户的权限不同，所能看到的页面和可操作性不同
  admin - > 所有页面都可以看到
  vip -> 属于vip的权限
  vips -> 更多的vip权限
*/
//------准备动态加载的路由
export const DynamicRoutes = [
  {
    path: '',
    component: Layout,
    name: 'container',
    redirect: '/instrument',
    meta: {
      requiresAuth: true,
      name: '仪表盘'
    },
    children: [
      {
        path: '/instrument',
        component: Instrument,
        name: 'instrument',
        title: '仪表盘',
        meta: {
          //---匹配规则
          name: "仪表盘",
          icon: require('@/assets/images/icon/instrument0.png')
        },
        show: true,
        children: []
      },
    ]
  },
  // {
  //   path: '/403',
  //   component: Forbidden
  // },
  //   {
  //   path: '*',
  //   component: NotFound
  // }
]



const router = new VueRouter({
  routes,
   // 👇 加上这个！！！
  scrollBehavior(to, from, savedPosition) {
    // 所有路由跳转，都强制回到顶部
    return { x: 0, y: 0 }
  }
})



export default router
